import React, { Component } from 'react';
import {MainLayout} from 'components/layouts';
import {OrdersOfBusinessList} from 'components/fair/fair-order';
import {Link} from 'react-router-dom';

export default class FairProductsOfBusiness extends Component {

  render() {
    return (
      <MainLayout>
        <div>
          <div className='mb15'>
            <Link className='btn-back' to={`/fair/${this.props.match.params.id}`}><i className='fa fa-chevron-left' />Quay về trang chi tiết hội chợ</Link>
          </div>
          <div className='wrap-heading'>
            <h1>Danh sách đơn hàng của doanh nghiệp</h1>
          </div>
          <OrdersOfBusinessList match={this.props.match}/>
        </div>
      </MainLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./pages/fair/fair-orders/FairOrdersOfBusiness.jsx